import { useState } from "react";
import { toast } from "sonner";
import { Building2, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function FranchiseEnquiry({ dark = true }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enquiries", form);
      setDone(true);
      toast.success("Enquiry sent — the league team will reach out.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Couldn't send that right now.");
    } finally {
      setBusy(false);
    }
  };

  const field = dark
    ? "w-full px-4 py-3 rounded-lg bg-white/10 border border-white/15 text-white text-sm placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-league-red"
    : "w-full px-4 py-3 rounded-lg bg-white border border-black/10 text-league-ink text-sm placeholder:text-league-ink/40 focus:outline-none focus:ring-2 focus:ring-league-blue";

  return (
    <div className={`${dark ? "backdrop-blur-xl bg-white/10 border-white/15 text-white" : "bg-white border-black/10 text-league-ink"} border rounded-2xl p-6 sm:p-10`} data-testid="franchise-enquiry">
      <div className="flex items-center gap-3 mb-2">
        <span className="inline-flex w-10 h-10 rounded-full bg-league-red text-white items-center justify-center">
          <Building2 size={18} />
        </span>
        <span className={`text-[11px] font-bold uppercase tracking-[0.25em] ${dark ? "text-league-red" : "text-league-blue"}`}>Own a Franchise</span>
      </div>
      <h3 className="font-display text-3xl sm:text-4xl tracking-tight">BUY A TEAM IN SEASON 6.0</h3>
      <p className={`${dark ? "text-white/60" : "text-muted-foreground"} text-sm mt-3 mb-6 max-w-xl leading-relaxed`}>
        Seven franchise slots, one of them could be yours. Leave your details and the All Star League team will call you back with pricing and availability.
      </p>
      {done ? (
        <p className="font-oswald text-lg font-semibold text-green-400" data-testid="enquiry-success">
          Enquiry received — we'll be in touch soon.
        </p>
      ) : (
        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="franchise-enquiry-form">
          <input required placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={field} data-testid="enquiry-name" />
          <input required placeholder="Phone / WhatsApp" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={field} data-testid="enquiry-phone" />
          <input type="email" placeholder="Email (optional)" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={field} data-testid="enquiry-email" />
          <input placeholder="Anything we should know? (optional)" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={field} data-testid="enquiry-message" />
          <div className="sm:col-span-2">
            <button
              type="submit"
              disabled={busy}
              data-testid="enquiry-submit"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-league-red text-white text-sm font-bold uppercase tracking-wider transition-colors duration-200 hover:bg-league-blue disabled:opacity-60"
            >
              {busy && <Loader2 size={15} className="animate-spin" />}
              Send enquiry
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
